<avd-styling-card-shell [label]="label">
    <div
        token-card-preview
        class="styling-swatch"
        [style.background-color]="swatchBackgroundColor"
        aria-hidden="true"
    ></div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
